var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('van-loading',{attrs:{"size":"26px","vertical":"","type":"spinner","color":"#1989fa"}},[_vm._v("获取中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }